module.exports = {
  container: 'dashboard/container',
  app: name => `dashboad/app/${name}`
}
